import useLanguageTree from '~/commons/language'
const {supportedLanguages, languagesRoot} = useLanguageTree()
const contractsURL = '/static/'
export default function useContracts () {
  async function getCheckedSource (contractName, currentLocale) {
    try {
      if (contractName) {
        const response = await fetch(`${contractsURL}${contractName}/${currentLocale}.html`)
        if (response.status !== 200) {
          throw new Error(`Not found ${contractsURL}${contractName}/${currentLocale}.html`)
        }
        return `${contractsURL}${contractName}/${currentLocale}.html`
      }
    } catch (err) {
      console.debug('missing translation, redirecting to fallback', err)
      if (currentLocale !== languagesRoot) {
        return getCheckedSource(contractName, supportedLanguages.get(currentLocale))
      }
    }
    return `${contractsURL}${contractName}/${languagesRoot}.html`
  }
  return {
    getCheckedSource
  }
}



// WEBPACK FOOTER //
// ./src/commons/contracts.js